module.exports = __webpack_public_path__ + "media/Shipping_IN.8ffa7f18.mp4";